import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=b6b39b18&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=b6b39b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b39b18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnForm: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-form.vue').default})
